import RlLogoProps from "./@types/RlLogoProps";
import { getLogoUri } from "./utils";

const RlLogo = (props: RlLogoProps) => {
  const { variant, width, height, alt, style, ...rest } = props;

  return (
    <img
      {...rest}
      src={getLogoUri(variant)}
      alt={alt ?? variant}
      width={width}
      height={height}
      style={{ ...style, width, height }}
    />
  );
};

export default RlLogo;
